import { useMedia } from 'react-use';
import { useTheme } from '../theme/theme';

export const useIsMobile = () => {
  const theme = useTheme();

  return useMedia(`(max-width: ${theme.breakpoints[0]})`);
};
